// utils/highlightStyles.ts

export const getHighlightStyles = (isActive) => {
    return isActive
      ? {
          // transition: "all 0.3s ease",
          position: "relative",
          zIndex: 9999,
          borderRadius: "3px",
          backgroundColor: "#fff",
        }
      : {};
  };
  
export const getItemHighlightStyles = (isActive) => {
  return isActive
    ? {
        fontWeight: "bold",
        color: "#1890ff",
      } :{};
  };

export const getItemHighlightTemplate = (isActive) => {
  return isActive
    ? {
      fontWeight: "bold",
      color: "#1890ff",
      // transition: "all 0.3s ease",
      position: "relative",
      backgroundColor: "#fff",
      zIndex: 9999,
      } :{};
  };